import { buildViewArticleEvent } from './page-view/article/event-builder.js';
import { buildViewSalesPosterEvent } from './page-view/salesposter/event-builder.js';
import { buildViewSalesPosterEvent as buildViewSalesPosterForNorwegianBrandsEvent } from './page-view/salesposter/for-norwegian-brands/event-builder.js';
import { buildViewListingEvent } from './page-view/listing/event-builder.js';
import { buildViewFrontpageEvent } from './page-view/frontpage/event-builder.js';
import { buildViewPageEvent } from './page-view/page/event-builder.js';
class NewsMediaPulseTracker {
    constructor(pulseTracker, actorPromise) {
        this.trackViewArticle = (inputProperties, trackOptions) => {
            const pageViewEventData = buildViewArticleEvent(inputProperties);
            return this.pulseTracker.trackPageView(pageViewEventData, trackOptions);
        };
        this.trackViewSalesPoster = (inputProperties, trackOptions) => {
            const viewSalesposterEventData = buildViewSalesPosterEvent(inputProperties);
            return this.pulseTracker.trackPageView(viewSalesposterEventData, trackOptions);
        };
        this.trackViewSalesPosterForNorwegianBrands = (inputProperties, trackOptions) => {
            const viewSalesposterEventData = buildViewSalesPosterForNorwegianBrandsEvent(inputProperties);
            return this.pulseTracker.trackPageView(viewSalesposterEventData, trackOptions);
        };
        this.trackViewListing = (inputProperties, trackOptions) => {
            const viewListingEventData = buildViewListingEvent(inputProperties);
            return this.pulseTracker.trackPageView(viewListingEventData, trackOptions);
        };
        this.trackViewFrontpage = (inputProperties, trackOptions) => {
            const viewFrontpageEventData = buildViewFrontpageEvent(inputProperties);
            return this.pulseTracker.trackPageView(viewFrontpageEventData, trackOptions);
        };
        this.trackViewPage = (inputProperties, trackOptions) => {
            const viewPageEventData = buildViewPageEvent(inputProperties);
            return this.pulseTracker.trackPageView(viewPageEventData, trackOptions);
        };
        this.pulseTracker = pulseTracker;
        if (actorPromise) {
            this.pulseTracker.update({ actor: actorPromise });
        }
    }
}
NewsMediaPulseTracker.fromAutotracker = (pulseAutotracker, actorPromise) => {
    return new Promise((resolve, reject) => {
        pulseAutotracker((pulseTracker) => {
            if (pulseTracker) {
                resolve(new NewsMediaPulseTracker(pulseTracker, actorPromise));
            }
            else {
                reject(new Error('Error getting pulse tracker'));
            }
        });
    });
};
export { NewsMediaPulseTracker };
//# sourceMappingURL=NewsMediaPulseTracker.js.map